<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { env } from '@configuration/env';
import ErrorPage from '../ErrorPage/ErrorPage.vue';

const showReload = ref(false);

onMounted(() => {
  const previousUrl = sessionStorage.getItem('previousUrl');
  if (previousUrl) {
    showReload.value = true;
    const url = env.BASE_URL + previousUrl;
    window.history.replaceState({}, '', url.replace('//', '/'));
    sessionStorage.removeItem('previousUrl');
  }
});
</script>

<template>
  <ErrorPage
    title="500"
    sub-title="Probleem tijdens het laden van de pagina"
    description="Er is een fout opgetreden bij het laden van de pagina."
    :show-reload="showReload"
  />
</template>
